import { render, staticRenderFns } from "./Plug4Market.vue?vue&type=template&id=acc8c486&scoped=true"
import script from "./Plug4Market.vue?vue&type=script&lang=js"
export * from "./Plug4Market.vue?vue&type=script&lang=js"
import style0 from "./Plug4Market.vue?vue&type=style&index=0&id=acc8c486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc8c486",
  null
  
)

export default component.exports